import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { CircleAlert } from 'lucide-react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../utils/testIds/OrderConditions.testIds';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import {
  getOrderConditionErrors,
  isOrderWideConditionError,
} from '../../../../../conditions/orderConditionFieldErrors.utils';
import { useOrderEditSectionsContext } from '../../../../../edit/sections/OrderEditSections.context';
import { useBusinessPolicyViolationViews } from '../../../../../edit/validate/conditions/businessPolicy/hooks/useBusinessPolicyViolationViews';
import OrderConditionErrorsTooltipContent from '../../OrderConditionErrorsTooltipContent/OrderConditionErrorsTooltipContent';
import OrderErrorIcon from '../../OrderErrorIcon';

interface OrderConditionErrorIconProps {
  conditionId: string;
}

const OrderConditionErrorIcon = ({ conditionId }: OrderConditionErrorIconProps) => {
  const { translate } = useTranslation();
  const { rawConditionErrors, openPolicyViolationsModal } = useOrderEditSectionsContext();

  const errors = getOrderConditionErrors(rawConditionErrors, conditionId).filter(
    (error) => !isOrderWideConditionError(error),
  );
  const policyViolations = useBusinessPolicyViolationViews(errors);

  if (!errors.length) {
    return null;
  }

  const openDetails = () => openPolicyViolationsModal(policyViolations);
  const tooltipContent = (
    <OrderConditionErrorsTooltipContent errors={errors} onOpenDetails={openDetails} />
  );

  if (!policyViolations.length) {
    return (
      <Tooltip interactive TooltipContent={tooltipContent}>
        <OrderErrorIcon testId={OrderConditionsTestIds.CONDITION_ERROR_ICON} />
      </Tooltip>
    );
  }

  return (
    <Tooltip interactive TooltipContent={tooltipContent}>
      <IconButton
        icon={CircleAlert}
        size="small"
        ariaLabel={translate(LangEnum.BUSINESS_POLICY_VIOLATION_SEE_DETAILS)}
        testId={OrderConditionsTestIds.CONDITION_ERROR_DETAILS_BUTTON}
        onClick={openDetails}
        sx={{ color: 'error.main' }}
      />
    </Tooltip>
  );
};

export default OrderConditionErrorIcon;
